import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div<any>`
  transition: opacity 300ms ease;
  ${props => !props.hasVariants && `
    cursor: wait;
    > * {
      pointer-events: none;
    }
  `}
`

export const Setting = {
  Option: styled.div`
    margin: 0 0 15px;
  `,

  Title: styled.div`
    font: ${font('default', 'bold', '14px')};
    margin: 0 0 5px;
  `
}
